import {
  fileExceedSizeInMo,
  IframelyMedia,
  imageHasMinDimensions,
  isImageFile,
  isVideoFile,
  mediaFromIframely,
  NotificationTypeEnum,
  OneMedia,
  PushNotificationFn,
} from '@prismamedia/one-components';
import { isArray } from 'lodash';

export enum MediaType {
  Image = 'Image',
  Video = 'Video',
  Other = 'Other',
}

interface dropConfig {
  mediaType: MediaType;
  files: File[];
  handleFiles: (files: File[]) => Promise<IframelyMedia[]> | Promise<OneMedia>;
  disableImgWidth?: boolean;
  pushNotification: PushNotificationFn;
}

export const handleDrop = async (
  dropConfig: dropConfig,
): Promise<OneMedia[]> => {
  const {
    mediaType,
    files,
    handleFiles,
    pushNotification,
    disableImgWidth = true,
  } = dropConfig;
  const correctFiles: File[] = [];
  const notificationError = (message: string) => {
    pushNotification({
      message,
      type: NotificationTypeEnum.error,
    });
  };

  // eslint-disable-next-line fp/no-loops
  for (const file of files) {
    const { name } = file;
    if (mediaType.includes(MediaType.Image)) {
      if (!isImageFile(file)) {
        notificationError(`Média ${name} non reconnu`);
      } else if (fileExceedSizeInMo(file, 10)) {
        notificationError(`Média ${name} supérieur à 10Mo`);
      } else if (
        !disableImgWidth &&
        !(await imageHasMinDimensions(file, 1280, 0))
      ) {
        notificationError(`Média ${name} inférieur à 1280px`);
      } else if (mediaType.includes(MediaType.Video)) {
        if (!isVideoFile(file))
          notificationError(`${file.name} n'est pas une video`);
        if (fileExceedSizeInMo(file, 1000))
          notificationError(`${file.name} est supérieur à 1Go`);
      } else {
        // eslint-disable-next-line fp/no-mutating-methods
        correctFiles.push(file);
      }
    } else {
      // eslint-disable-next-line fp/no-mutating-methods
      correctFiles.push(file);
    }
  }

  if (correctFiles.length === 0) return [];

  try {
    const iframelys = await handleFiles(correctFiles);
    if (mediaType === MediaType.Image && isArray(iframelys)) {
      return iframelys.map(mediaFromIframely);
    }
    return [iframelys] as OneMedia[];
  } catch (error) {
    notificationError(`Erreur lors de l'ajout du media : ${error}`);
    return [];
  }
};
